import React, {Component} from "react";
import {connect} from "react-redux";
import {closeDatePicker} from "../../actions/ViewActions";
import ActionButton from "../ActionButton";
import {fromJS, Map} from "immutable";
import Calendar from "../Calendar";
import MessageBus from "../../lib/MessageBus";
import parse from "date-fns/parse";
import isValid from "date-fns/is_valid";
import "./DatePickerWindow.css";

class DatePickerWindow extends Component{

  constructor(props) {
    super(props);
    this.state = { 
      errors: [],
      currentMonth: new Date(),
      selectedDate: new Date()    
    }
  }

  componentDidMount() {
    let selectedDate = parse(this.props.date);
    if (isValid(selectedDate)) {
      this.setState({selectedDate: selectedDate, currentMonth: selectedDate});
    }
  }  

  handleConfirmDate(date) {
    MessageBus.publish("DatePicker", this.props.field, date);
    this.props.closeDatePicker();
  }

  handleSelectDate(date) {
    this.setState({selectedDate: date});
  }

  handleSubmit() {
    MessageBus.publish("DatePicker", this.props.field, this.state.selectedDate);
    this.props.closeDatePicker();    
  }

  handleCancel() {
    this.props.closeDatePicker();
  }

  handleSetCurrentMonth(date) {
    this.setState({currentMonth: date});
  }

  render() {
    let options = fromJS(this.props.options);
    let disableWeekends = options.get("disableWeekends", false);
    let unavailableDates = fromJS(options.get("unavailableDates", Map()));
    let notBeforeDate = null;
    let notAfterDate = null;
    if (options.has("notBeforeDate")) {
      notBeforeDate = options.get("notBeforeDate");
    }
    if (options.has("notAfterDate")) {
      notAfterDate = options.get("notAfterDate");
    }
    return (
      <React.Fragment>
        <Calendar 
          selectedDate={this.state.selectedDate}
          currentMonth={this.state.currentMonth}
          disableWeekends={disableWeekends}
          unavailableDates={unavailableDates}
          onSetCurrentMonth={this.handleSetCurrentMonth.bind(this)}
          onConfirm={this.handleConfirmDate.bind(this)}
          onSelect={this.handleSelectDate.bind(this)}
          notBeforeDate={notBeforeDate}
          notAfterDate={notAfterDate}
          />
        <div className="Calendar-footer">
          <ActionButton label="Cancel" active={true} onClick={this.handleCancel.bind(this)} />
          <ActionButton label="Submit" onClick={this.handleSubmit.bind(this)} active={true} />
        </div>
      </React.Fragment>
    )
  }

}

export default connect(null, {closeDatePicker})(DatePickerWindow);
